import React from "react";

const RentingOrder = (props: any) => {
  const { rentingProducts, currentRentProductQuantity } = props;

  return (
    <>
      {rentingProducts.filter((item: any) => item.selectedQuantity > 0).length >
        0 && (
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Product</th>
              <th>Duration</th>
              <th>Start Time</th>
              <th>Qty</th>
              <th>Price</th>
            </tr>
          </thead>
        )}

      <tbody>
        {rentingProducts?.map((item: any, index: number) => {
          if (item?.selectedQuantity === 0) {
            return null;
          }
          return (
            <tr key={"rent-order-" + item?.id}>
              <td>{index + 1}</td>
              <td className="text-overlapping" title={item.name}>
                {item.name}
              </td>
              <td>{item.duration} Min</td>
              <td>{item.startTime}</td>
              <td>{currentRentProductQuantity?.[item?.id]}</td>
              <td className="text-nowrap">
                <span className="rupees-symbol">&#8377;</span>{" "}
                {(
                  (item.duration / 30) *
                  item.selectedQuantity *
                  item.rentingPrice
                )?.toFixed(2)}{" "}
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export { RentingOrder };
